import CustomTable from "components/CustomTable";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { Button } from "@mui/material";
import moment from "moment";

export default function BlackoutDatesTable({
  data = {},
  onDelete = () => {},
  onView = () => {},
}) {
  return (
    <div className="my-2">
      <CustomTable
        pageCount={50}
        height={650}
        data={data}
        columns={[
          { label: "Name", selector: "name" },
          {
            label: "Blackout Day",
            selector: "blackout_day",
            sortValue: (row) => moment(row?.blackout_day).unix(),
            cell: (row) => moment(row?.blackout_day).format("YYYY-MM-DD"),
          },
          {
            label: "Actions",
            selector: "actions",
            cell: (row, index) => (
              <div className="flex items-center">
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => onView(row, index)}
                >
                  Edit
                </Button>
                <Button
                  className="mx-1"
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => onDelete(row, index)}
                >
                  Delete
                </Button>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
